<template>
    <div class="content">
        <div class="cat">
            <div class="row">
                <div class="col-sm-12">{{$t('consigliperte')}}</div>
            </div>
        </div>

        <div class="content-list">
            <inc-product-list :products="this.products"/>
        </div><!-- /.content-list -->
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import {getProductsListByFilter} from '../../api/restaurant';
    import {getUsableProducts} from '../../libraries/utils';

    import IncProductList from './partials/IncProductList';

    export default {
        name: "Advices",
        components: {IncProductList},
        data() {
            return {
                products: []
            }
        },
        created() {
            this.fetch();
        },
        computed: {
            ...mapState('localization', {
                language: state => state.language
            }),
            ...mapState('restaurant', {
                id_ristorante: state => state.id,
                locale: state => state.locale
            }),
            ...mapState('order', {
                order: state => state
            })
        },
        methods: {
            fetch: function () {
                this.showLoading(true);

                getProductsListByFilter(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_menu: this.order.id_menu,
                    ids: this.$route.query.ids
                }).then((response) => {
                    this.products = getUsableProducts(response.prodotti, this.locale.id, this.order.type);
                }).catch(({messages}) => {
                    alert(messages.join('\n'));
                }).finally(() => {
                    this.showLoading(false);
                });

            },
            ...mapActions('global', [
                'showLoading'
            ])
        }
    }
</script>
